import { API_URL, apiRequest } from './api';
import axios, { AxiosResponse } from 'axios';
import { getAuthToken } from '../components/security/AuthContext';
import { Agent } from '../components/model';

const API_AI_AGENT_URL = `${API_URL}/ai-agent`;

// Agents API Methods
export const fetchAllAgents = async () => {
  return apiRequest('GET', API_AI_AGENT_URL);
};

export const fetchAgentByUuid = async (uuid: string) => {
  return apiRequest('GET', `${API_AI_AGENT_URL}/${uuid}`);
};

export const saveOrUpdateAgent = async (agent: Agent): Promise<Agent> => {
  return apiRequest('POST', API_AI_AGENT_URL, agent) as Promise<Agent>;
};

export const deleteAgent = async (uuid: string) => {
  return apiRequest('DELETE', `${API_AI_AGENT_URL}/${uuid}`);
};

export const processFile = async (
  agentUuid: string,
  formData: FormData,
  onProgress: (progress: number) => void
): Promise<string> => {
  try {
    const response: AxiosResponse<string> = await axios.post(
      `${API_URL}/ai-agent/${agentUuid}/process-file`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${getAuthToken()}`,
        },
        onUploadProgress: progressEvent => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total!
          );
          onProgress(progress); // Update progress
        },
      }
    );

    return response.data;
  } catch (error: unknown) {
    console.error(
      'Error uploading file:',
      error instanceof Error ? error.message : 'Unknown error'
    );
    if (error && typeof error === 'object' && 'response' in error) {
      const axiosError = error as {
        response?: { data?: { message?: string } };
      };
      throw new Error(
        axiosError.response?.data?.message || 'Error processing file'
      );
    }
    throw new Error('Error processing file');
  }
};
